import dayjs from "dayjs"

const defaultToday = dayjs()

/**
 * 預設資料時間區間
 * @param {Date} start 生效時間
 * @param {Date} end 結束時間
 * @param {Date} today 今天
 * @param {number} base 基準日 預設為 D - 2
 * @returns {Array} [預設開始時間, 預設結束時間]
 */
export default function (start, end, today = defaultToday, base = 2) {
    today = initialDate(today)
    const baseDay = today.subtract(base, "day")
    const endDate = dayjs(end)
    const startDate = dayjs(start)

    // 如果結束時間在基準日之後，使用基準日
    const finalEndDate = dayjs(endDate).isAfter(baseDay) ? baseDay : endDate

    return [startDate, finalDate(finalEndDate)].map((d) => d.toISOString())
}

/**
 * 取得當天起點
 * @param {Date} day 當天日期
 * @returns {Date} 當天起點
 */
export function initialDate(day) {
    return dayjs(day)
        .set("hour", 0)
        .set("minute", 0)
        .set("second", 0)
        .set("millisecond", 0)
}

/**
 * 取得當天終點
 * @param {Date} day 當天日期
 * @returns {Date} 當天終點
 */
export function finalDate(day) {
    return dayjs(day)
        .set("hour", 23)
        .set("minute", 59)
        .set("second", 59)
        .set("millisecond", 999)
}
